import "./LayoutWizardServiceprovider.scss";
import LayoutWizardServiceproviderDialog from "@/components/LayoutWizard/LayoutWizardServiceproviderDialog/LayoutWizardServiceproviderDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getTokenHeader } from "@/helpers/commonHelper";
import * as layoutWizardHelper from "@/helpers/layoutWizardHelper";
import * as XLSX from "xlsx";
import * as _ from "lodash";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
export default {
  name: "LayoutWizardServiceprovider",
  components: { LayoutWizardServiceproviderDialog },
  props: ["update"],
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          value: "title"
        },
        { text: "Externe Id", value: "tomas_id" },
        { text: "Ort", value: "address.city" },
        { text: "Status", value: "status" },
        { text: "letzte Aktivität", value: "last_action" },
        {
          text: "Aktionen",
          value: "actions",
          sortable: false,
          align: "center",
          width: "10%"
        }
      ],
      config: {},
      search: "",
      searchPoi: "",
      searchSp: "",
      debouncePoiSearch: null,
      debounceTravelSearch: null,
      editDialog: false,
      editedItem: {},
      poiDialog: false,
      travelDialog: false,
      isLoadingPoi: false,
      updateTimespan: "day",
      importInfo: "",
      poiItems: [],
      spItems: [],
      poiMessage: "",
      importPoi: "",
      importSp: "",
      username: "",
      password: "",
      notImported: false,
      snackbar: false,
      snackbarColor: "#000",
      snackbarText: "asdf",
      defaultItem: {
        address: {
          contact_person: "",
          zip: "",
          street: "",
          phone: "",
          web: "",
          email: "",
          fax: "",
          city: ""
        },
        payment: {
          last_name: "",
          zip: "",
          city: "",
          street: " ",
          first_name: "",
          title: "",
          salutation: ""
        },
        title: "",
        title_ascii: "",
        sort_title: "",
        sort_title_ascii: "",
        principal_id: "",
        tomas_id: "",
        login: "",
        login_token: "",
        status: "",
        is_test_user: false,
        contact_declined: false,
        features: [],
        last_action: "",
        sp_type: "",
        data: {},
        last_login: "",
        changed: "",
        created: ""
      },
      serviceproviders: [],
      editPwItem: { title: "", password: "", _id: null },
      editPwDialog: false,
      showPw: false,
      ignoreFilter: false,
      loading: true,
      loadingOverlay: false,
      options: {},
      total: 0,
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      page: 1,
      itemsPerPage: 10,
      pageCount: 0
    };
  },
  watch: {
    options() {
      this.loadServiceproviders();
    },
    search(val) {
      this.options.page = 1;
      if (val?.length >= 3) this.loadServiceproviders();
      if (val === "") this.loadServiceproviders();
    },
    async searchPoi(val) {
      this.debouncePoiSearch(val);
    },
    async searchSp(val) {
      this.debounceTravelSearch(val);
    }
  },
  computed: {
    principalTravelAdWizardSettings() {
      const { travelAdWizard } =
        this.$store.state.selectedPrincipal?.additional_data || {};
      if (!travelAdWizard?.active) {
        return { active: false };
      }
      return travelAdWizard;
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isPoiValid() {
      return (
        this.password && this.username && this.importPoi && this.notImported
      );
    },
    isSpValid() {
      return (
        this.password && this.username && this.importSp && this.notImported
      );
    }
  },
  async mounted() {
    await this.loadConfig();
    this.loadServiceproviders();
    //this.update if route is: /anzeigenassistent/serviceproviders/update/:id
    if (this.update) {
      this.fetchSp(this.update);
    }
    this.debouncePoiSearch = _.debounce(this.searchPoiFunc, 200);
    this.debounceTravelSearch = _.debounce(this.searchSpFunc, 200);
  },
  methods: {
    ...layoutWizardHelper,
    nextPage() {
      const totalPages = Math.ceil(this.total / this.itemsPerPage);
      if (this.page < totalPages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    async fetchSp(id) {
      const headers = getTokenHeader();
      this.$refs.spDialog.loadingStatus(true);
      try {
        const response = await axios.get(
          env.assistent_api_client_url + "service_providers/" + id,
          {
            headers
          }
        );
        this.editedItem = Object.assign({}, response.data);
        this.$refs.spDialog.fillData(this.editedItem);
        this.editDialog = true;
      } catch (error) {
        this.close();
        this.createError(error);
      }
      this.$refs.spDialog.loadingStatus(false);
    },
    getServiceproviderSearchParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const params = {
        query: this.search,
        principal_id: this.currentPrincipal,
        limit: itemsPerPage,
        offset: (page - 1) * itemsPerPage,
        sort: sortBy,
        direction: sortDesc ? "desc" : "asc",
        with_login_tokens: 1
      };

      // filter by features (f.e. season-feature)
      if (
        !this.ignoreFilter &&
        this.config.sp_features &&
        this.config.sp_features[0]["filterFeatures"]
      ) {
        const filterFeatures = this.config.sp_features[0]["filterFeatures"];
        params["features"] = filterFeatures.join(",");
      }

      return params;
    },
    async loadServiceproviders() {
      if (!this.config) {
        return;
      }
      this.loading = true;
      const headers = getTokenHeader();
      const params = this.getServiceproviderSearchParams();

      try {
        const response = await axios.get(
          env.assistent_api_client_url + "service_providers/",
          {
            headers,
            params
          }
        );
        this.serviceproviders = response.data;
        let count = response?.headers?.["x-count"];
        if (isNaN(count)) {
          console.error("no number in x-count");
        }
        this.total = parseInt(count);
      } catch (error) {
        this.createError(error);
      }
      this.loading = false;
    },
    statusColor(item) {
      if (item.status === "green") {
        return this.mainPeacock;
      }
      if (item.status === "" || item.status === "none") {
        return "#c7c7c7";
      }
      return item.status;
    },
    createItem() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.isNew = true;
      this.editedItem.principal_id = this.currentPrincipal;
      this.$refs.spDialog.fillData(this.editedItem);
      this.editDialog = true;
    },
    editItem(item) {
      this.editedIndex = this.serviceproviders.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.isNew = false;
      //prefill cached data
      this.$refs.spDialog.fillData(this.editedItem);
      this.editDialog = true;
      //refresh data
      this.fetchSp(item._id);
    },
    editPw(item) {
      this.editPwItem = { ...item };
      this.editPwDialog = true;
    },
    async savePw(item) {
      if (item.password.length < 3) return;
      this.loadingOverlay = true;
      try {
        const headers = getTokenHeader();
        await axios.put(
          `${env.assistent_api_client_url}service_providers/${item._id}`,
          { password: item.password },
          { headers }
        );
        this.snackMessage("Erfolgreich gespeichert!");
      } catch (error) {
        this.createError(error);
      }
      this.loadingOverlay = false;
      this.editPwDialog = false;
    },
    deleteItem(item) {
      this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          try {
            await this.deleteSp(item);
          } catch (err) {
            this.createError(err);
            return;
          }
          this.editedIndex = this.serviceproviders.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.$refs.spDialog.fillData(this.editedItem);
          this.serviceproviders.splice(this.editedIndex, 1);
          this.closeDelete();
        }
      });
    },
    async deleteSp(item) {
      const title = item.title;
      const headers = getTokenHeader(),
        res = await axios.delete(
          `${env.assistent_api_client_url}service_providers/${item._id}`,
          { headers }
        );
      if (res.status === 200) {
        this.snackMessage(title + " gelöscht!", "#000");
      } else {
        this.snackMessage(
          item.title + " konnte nicht gelöscht werden!",
          this.mainRed
        );
      }
    },
    afterSave(close) {
      if (this.editedIndex > -1) {
        Object.assign(this.serviceproviders[this.editedIndex], this.editedItem);
      } else {
        this.serviceproviders.push(this.editedItem);
      }
      this.loadServiceproviders();
      if (close) {
        this.close();
      }
      this.snackMessage("Erfolgreich gespeichert!");
    },
    close() {
      if (this.update) {
        this.$router.push(`/anzeigenassistent/service_providers/`);
        this.editDialog = false;
        return;
      }
      this.editDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.$refs.spDialog.fillData(this.editedItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.$refs.spDialog.fillData(this.editedItem);
        this.editedIndex = -1;
      });
    },

    async getSpFullList() {
      const params = this.getServiceproviderSearchParams();
      params["limit"] = 9999;
      params["offset"] = 0;
      if (this.isAdmin) {
        params["with_password_for_login_list"] = 1;
      }
      let serviceProviders = [];
      const headers = getTokenHeader();
      try {
        const response = await axios.get(
          env.assistent_api_client_url + "service_providers/",
          {
            headers,
            params
          }
        );
        serviceProviders = response.data;
      } catch (error) {
        this.createError(error);
      }

      return serviceProviders;
    },

    // download list
    async downloadList() {
      this.loadingOverlay = true;
      const serviceProviders = await this.getSpFullList();

      // add title line
      const data = [
        [
          "Name",
          "Externe Id",
          "Straße",
          "PLZ",
          "Ort",
          "Kontaktperson",
          "Telefon",
          "Fax",
          "E-Mail",
          "Status",
          "letzte Aktivität",
          "Test-Benutzer?",
          "Login-Name",
          this.isAdmin ? "Password" : ""
        ]
      ];

      for (const serviceProvider of serviceProviders) {
        data.push([
          serviceProvider.title,
          serviceProvider.tomas_id,
          serviceProvider?.address?.street ?? "---",
          serviceProvider?.address?.zip ?? "---",
          serviceProvider?.address?.city ?? "---",
          serviceProvider?.address?.contact_person ?? "---",
          serviceProvider?.address?.phone ?? "---",
          serviceProvider?.address?.fax ?? "---",
          serviceProvider?.address?.email ?? "---",
          serviceProvider.contact_declined ? "kein Kontakt gewünscht" : "",
          serviceProvider?.last_action?.toString()?.dateFormat() ?? "",
          serviceProvider.is_test_user ? "ja" : "",
          serviceProvider.login || "",
          this.isAdmin ? serviceProvider?.password || "" : ""
        ]);
      }

      // create XLSX file structure
      const ws = XLSX.utils.aoa_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Leistungsträger");
      XLSX.writeFile(workbook, "leistungstraeger.xlsx");
      this.loadingOverlay = false;
    },

    // download sp list configuration: config.export_config.customSpList
    async downloadSpList() {
      this.loadingOverlay = true;
      const serviceProviders = await this.getSpFullList();

      const customSpFilename =
        this?.config?.export_config["customSpFilename"] ??
        "anzeigen-liste.xlsx";

      const customSpList = this?.config?.export_config["customSpList"] ?? false;

      if (!customSpList) {
        this.snackMessage("no customSpList-config!", "#c55c52");
        this.loadingOverlay = false;
        return;
      }

      const headArr = [];

      for (const k in customSpList) {
        headArr.push(k);
      }
      // add title line
      const data = [headArr];

      for (const sp of serviceProviders) {
        const lineArr = [];
        for (const column in customSpList) {
          lineArr.push(
            // column content or default value "-"
            _.get(sp, customSpList[column], "-")
          );
        }
        data.push(lineArr);
      }

      // create XLSX file structure
      const ws = XLSX.utils.aoa_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, "Anzeigen");
      XLSX.writeFile(workbook, customSpFilename);
      this.loadingOverlay = false;
    },
    togglePoiDialog() {
      this.poiDialog = !this.poiDialog;
    },
    toggleTravelDialog() {
      this.travelDialog = !this.travelDialog;
    },
    async submitPoiImport() {
      this.isLoadingPoi = true;
      const headers = getTokenHeader();
      try {
        const response = await axios.post(
          env.assistent_api_client_url + "sync_poi",
          {
            poiId: this.importPoi._id,
            username: this.username,
            password: this.password,
            principal: this.$store.state.selectedPrincipal.id
          },
          { headers }
        );
        console.info({ imported: response.data });
        this.snackMessage(`${response.data.title} erfolgreich Importiert`);
        this.search = this.username;
      } catch (error) {
        console.error(error);
        this.snackMessage(
          `Fehler beim Importieren von ${this.importPoi.title}`,
          this.mainRed
        );
      }
      this.password = "";
      this.username = "";
      this.importPoi = "";
      this.poiDialog = false;
      this.isLoadingPoi = false;
    },
    async submitSpImport() {
      this.isLoadingPoi = true;
      const headers = getTokenHeader();
      try {
        const response = await axios.post(
          env.assistent_api_client_url + "sync_travel_provider",
          {
            gid: this.importSp.gid,
            username: this.username,
            password: this.password,
            principal: this.$store.state.selectedPrincipal.id
          },
          { headers }
        );
        this.snackMessage(`${response.data.title} erfolgreich Importiert`);
        this.search = this.username;
      } catch (error) {
        console.error(error);
        this.snackMessage(
          `Fehler beim Importieren von ${this.importSp.betriebsname}`,
          this.mainRed
        );
      }
      this.password = "";
      this.username = "";
      this.importSp = "";
      this.travelDialog = false;
      this.isLoadingPoi = false;
    },
    async refreshServiceproviders() {
      this.isLoadingPoi = true;
      this.importInfo = "";
      const headers = getTokenHeader();
      try {
        const response = await axios.post(
          env.assistent_api_client_url + "sync_poi/refreshSp",
          {
            principal: this.$store.state.selectedPrincipal.id,
            sync_poi_all: this.updateTimespan === "all"
          },
          { headers }
        );
        console.info({ imported: response.data });
        this.importInfo = response.data;
        this.snackMessage(`Serviceproviders erfolgreich aktualisiert`);
        this.search = "";
      } catch (error) {
        console.error(error);
        this.snackMessage(`Fehler beim Importieren`, this.mainRed);
      }
      this.isLoadingPoi = false;
    },

    async searchPoiFunc(val) {
      const headers = getTokenHeader();
      try {
        const response = await axios.get(env.poi_api_client_url + "poi/", {
          params: {
            $search: val,
            "$sort[title]": true,
            currentPrincipal: this.$store.state.selectedPrincipal.id
          },
          headers
        });
        this.poiItems = response?.data?.data;
      } catch (error) {
        console.error(error);
      }
    },
    async searchSpFunc(val) {
      try {
        const response = await axios.get(
          this.principalTravelAdWizardSettings.apiUrl,
          {
            params: {
              $search: val,
              mandanten: this.principalTravelAdWizardSettings.travelPrincipalId,
              apiKey: this.principalTravelAdWizardSettings.apiKey
            }
          }
        );
        this.spItems = response?.data?.data;
      } catch (error) {
        console.error(error);
      }
    },
    async changedPoi() {
      this.poiMessage = "";
      this.username = "";
      this.notImported = false;
      const headers = getTokenHeader();
      try {
        const response = await axios.get(
          env.assistent_api_client_url + "service_providers/",
          {
            params: {
              query: "awc",
              principal_id: this.$store.state.selectedPrincipal.id,
              sort: "login",
              limit: 999
            },
            headers
          }
        );
        const serviceProvider = response?.data;
        const alreadyImported = serviceProvider.find(
          sp => sp.tomas_id === this.importPoi._id
        );
        if (alreadyImported) {
          this.poiMessage = "Poi bereits importiert!";
          return;
        }
        this.notImported = true;
        const highest = serviceProvider.slice(-1)[0];
        const userNumber = parseInt(highest.login.replace("awc", ""));
        this.username = "awc" + (userNumber + 1);
        this.genPassword();
      } catch (error) {
        console.error(error);
      }
    },
    async changedSp() {
      this.poiMessage = "";
      this.username = "";
      this.notImported = false;
      const headers = getTokenHeader();
      try {
        const response = await axios.get(
          env.assistent_api_client_url + "service_providers/",
          {
            params: {
              principal_id: this.$store.state.selectedPrincipal.id,
              tomas_id: this.importSp.gid
            },
            headers
          }
        );
        const serviceProvider = response?.data;
        const alreadyImported = serviceProvider.find(
          sp => sp.tomas_id === this.importSp.gid
        );
        if (alreadyImported) {
          this.poiMessage = "Gastgeber bereits importiert!";
          return;
        }
        this.notImported = true;
        this.username = `gid_${this.importSp.gid}`;
        this.genPassword();
      } catch (error) {
        console.error(error);
      }
    },
    genPassword() {
      const chars = "0123456789abcdefghijklmnopqrstuvwxyz";
      const passwordLength = 8;
      let password = "";
      for (var i = 0; i <= passwordLength; i++) {
        var randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber + 1);
      }
      this.password = password;
    }
  }
};
